import { TbQuote, TbX } from "solid-icons/tb";
import { type Component, Show, createSignal, onCleanup } from "solid-js";
import { twMerge } from "tailwind-merge";

export const PromptBarQuote: Component<{ quote: string; onClose: () => void }> = (props) => {
  const [popOut, setPopOut] = createSignal(false);

  let hoverTimeout: NodeJS.Timeout | undefined;
  let focusTimeout: NodeJS.Timeout | undefined;
  let ref!: HTMLDivElement;

  const handleHoverStart = () => {
    hoverTimeout = setTimeout(() => {
      setPopOut(true);
    }, 500);
  };

  const handleHoverEnd = () => {
    if (hoverTimeout) {
      clearTimeout(hoverTimeout);
      hoverTimeout = undefined;
    }
    setPopOut(false);
  };

  const handleFocus = () => {
    focusTimeout = setTimeout(() => {
      setPopOut(true);
    }, 500);
  };

  const handleBlur = () => {
    if (focusTimeout) {
      clearTimeout(focusTimeout);
      focusTimeout = undefined;
    }
    setPopOut(false);
  };

  onCleanup(() => {
    if (hoverTimeout) clearTimeout(hoverTimeout);
    if (focusTimeout) clearTimeout(focusTimeout);
  });

  return (
    <div class="px-1 pt-1 mb-2 relative">
      <div
        tabindex={0}
        ref={ref}
        class="relative animate-fade-in transition-all select-none cursor-pointer flex items-start gap-2 rounded-t-[1.2rem] bg-inset px-3 py-2 pt-3"
        onMouseEnter={handleHoverStart}
        onMouseLeave={handleHoverEnd}
        onFocus={handleFocus}
        onBlur={handleBlur}
      >
        <TbQuote class="text-disabled-text" />
        <p
          class={twMerge(
            "whitespace-pre-wrap transition-all h-full max-h-[2.9rem] overflow-y-hidden text-xs text-left pr-2",
            popOut() && "max-h-[6.6rem] overflow-y-auto",
          )}
        >
          {props.quote}
        </p>
        <Show when={!popOut()}>
          <div class="pointer-events-none absolute left-0 right-0 bottom-0 h-10 rounded-b-[1.2rem] bg-gradient-to-b from-transparent to-inset" />
        </Show>
        <button
          type="button"
          onClick={props.onClose}
          class="group/x rounded-full bg-panel hover:bg-panel-hover p-1 relative -top-1 -right-1 cursor-pointer"
        >
          <TbX class="size-3 group-hover/x:scale-110 group-active/x:scale-95" />
        </button>
      </div>
    </div>
  );
};
